<template>
  <div class="max-w-5xl mx-auto space-y-8">
    <Registrations :account-id="accountId" />
    <Phones :account-id="accountId" />
    <Emails :account-id="accountId" />
  </div>
</template>

<script>
import Phones from '@/components/AccountSettings/Phones.vue';
import Emails from '@/components/AccountSettings/Emails.vue';
import Registrations from '@/components/AccountSettings/Registrations.vue';

export default {
  components: {
    Phones,
    Emails,
    Registrations,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
};
</script>
